import { React, Table } from '@1337lawyers/design';

export const PendingVerificationRequests = () => (
  <Table headers={['Task', 'Requested', 'Status']} data={[]} />
);
